import { useMutation } from '@tanstack/react-query'

import { getAddressSuggestion } from '../api/getAdressSuggestion'

export type ALLOWED_COUNTRIES = 'de' | 'ch' | 'at'

export const useAddressSuggestion = () => {
	const { mutate, ...rest } = useMutation({ mutationFn: getAddressSuggestion })

	return {
		getAddressSuggestion: mutate,
		...rest,
	}
}
